import React from 'react';
import Link from 'next/link';

import PostCategory from '../../PostCategory/PostCategory';
import Divider from '../../Divider/Divider';
import ReadingTime from '../../ReadingTime/ReadingTime';

import { IRelatedPost } from '../../../lib/types';
import { GTM_CLASS, GTM_CLASS_PREFIX } from '../../../lib/constant';

import styles from '../RelatedPostV2/RelatedPostV2.module.scss';
import classnames from 'classnames';
import { parseCategories } from '../../../utils/parseCategories';
import { parseFeaturedImage } from '../../../utils/parsePost';

interface IProps {
  relatedPosts: IRelatedPost[];
}

const RelatedPostV2 = ({ relatedPosts }: IProps): JSX.Element => {
  return (
    <div className={styles['widget-related-post']}>
      <div className={styles['post__card']}>
        <div className={styles['post__card--header']}>Artikel Terkait Lainnya</div>
        <div className={styles['post__card--body']}>
          <div className={styles['widget-related-post__list']}>
            {relatedPosts && relatedPosts.length > 0 ? (
              relatedPosts.map((post) => {
                const featuredImage = parseFeaturedImage(post);

                return (
                  <div key={post.slug} className={styles['widget-related-post__item']}>
                    <div className={styles['widget-related-post__item-head']}>
                      {featuredImage && (
                        <div className={styles['widget-related-post__item-featured-image']}>
                          <img
                            src={featuredImage.sourceUrl}
                            height="48px"
                            width="48px"
                            alt={post.title}
                            loading="lazy"
                          />
                        </div>
                      )}
                      <Link
                        href={{
                          pathname: `/[slug]`,
                        }}
                        as={`/${post.slug}`}
                        prefetch={false}
                      >
                        <a
                          className={classnames(
                            styles['widget-related-post__item-title'],
                            GTM_CLASS.VIEW_MORE_ARTICLE,
                            `${GTM_CLASS_PREFIX}${parseCategories.getSlug(post.categories)}`,
                          )}
                          title={post.title}
                        >
                          {post.title}
                        </a>
                      </Link>
                    </div>
                    <div className={styles['widget-related-post__item-meta']}>
                      <PostCategory categories={post.categories} />
                      <Divider />
                      <ReadingTime time={post.readingTime} />
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={styles['widget-related-post__item']}>
                Artikel terkait tidak ditemukan
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedPostV2;
